__turbopack_context__.v({
  "closeButton": "LocationBlockItem-module-scss-module__HOabaa__closeButton",
  "insertSection": "LocationBlockItem-module-scss-module__HOabaa__insertSection",
  "logo": "LocationBlockItem-module-scss-module__HOabaa__logo",
  "mapInsert": "LocationBlockItem-module-scss-module__HOabaa__mapInsert",
});
